import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { useLocation } from "react-router-dom";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { updateBooking, updateGuest } from "../../graphql/mutations";
import { FaSignature } from "react-icons/fa";
import { MdNavigateNext, MdOutlineDone, MdEmail } from "react-icons/md";
import { BsBookFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { AiFillCreditCard, AiTwotoneBulb } from "react-icons/ai";
import {
  Button,
  Center,
  CircularProgress,
  Flex,
  Grid,
  GridItem,
  Icon,
  Text,
  Box,
  InputGroup,
  Input,
  InputLeftElement,
  Card,
  useToast,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import Main from "./Main";
import { getBooking, getGuest } from "../../graphql/queries";
import { ApplePaySuperhog } from "../Mini/applePaySuperhog";
import { SecuritySteps } from "../Security/securitySteps";
import { useSelector } from "react-redux";
import { IntroVideoDrawer } from "../Mini/IntroVideoDrawer";
import { FormsDrawer } from "../Mini/FormsDrawer";
import { MdOutlineAssignment } from "react-icons/md";
import { listFormsForBooking } from "../../Backend/Forms/formsApi";

// Desktop shell for onboarding steps: centers the step in a card on md+
// screens so the flow reads as a focused dialog instead of a stretched
// mobile column. On base it renders children untouched (plain fragment
// semantics — same DOM nesting, no visual change on phones).
const OnboardingShell = ({ children }) => (
  <Box minH={{ md: "100vh" }} position="relative" overflow={{ md: "hidden" }}>
    <Box
      display={{ base: "none", md: "block" }}
      position="absolute"
      inset={0}
      pointerEvents="none"
      background="radial-gradient(720px circle at 50% 30%, rgba(129, 126, 255, 0.12), transparent 65%)"
    />
    <Flex
      position="relative"
      direction="column"
      maxW={{ md: "600px" }}
      mx="auto"
      px={{ md: 6 }}
      py={{ md: 10 }}
      minH={{ md: "100vh" }}
      justifyContent={{ md: "center" }}
    >
      <Box
        bg={{ md: "rgba(255, 255, 255, 0.03)" }}
        border={{ md: "1px solid rgba(255, 255, 255, 0.08)" }}
        borderRadius={{ md: "24px" }}
        px={{ md: 8 }}
        py={{ md: 8 }}
      >
        {children}
      </Box>
    </Flex>
  </Box>
);

const StepDisplay = ({ step, filled }) => {
  return (
    <Box
      w={"30px"}
      h={"5px"}
      borderRadius="full"
      bg={filled ? "#6C60FD" : "#6c60fe3b"}
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
    />
  );
};

const IntialDisplay = ({ handleStatusChange }) => {
  return (
    <>
      <Flex
        px={4}
        h={{ base: "66vh", md: "auto" }}
        justifyContent={"flex-start"}
        flexDirection="column"
        mt={{ base: "70px", md: 0 }}
        mb={{ md: 8 }}
      >
        <Center flexDirection="column" alignItems={"start"}>
          <Text fontWeight={400}>Onboarding</Text>
          {/* <Text fontWeight={800} fontSize={"24px"} pt={"2px"}>
            Let’s set you up
          </Text> */}
          <Text fontWeight={800} fontSize={"24px"} pt={"2px"}>
            About this app
          </Text>
          {/* <Text mt={1} fontWeight={800} fontSize={"14px"}>
            What we need
          </Text> */}
        </Center>

        {/* <Grid templateColumns="repeat(2, 1fr)" gap={6} mt={3}>
          <GridItem>
            <Flex flexDirection={"column"}>
              <Icon as={FaSignature} mr="2" fontSize={"50px"} />
              <Text fontWeight={800} fontSize={"12px"} pt={"8px"}>
                Your Signature
              </Text>
            </Flex>
          </GridItem>
          <GridItem>
            <Flex flexDirection={"column"}>
              <Icon as={AiFillCreditCard} mr="2" fontSize={"50px"} />
              <Text fontWeight={800} fontSize={"12px"} pt={"8px"}>
                Your Credit Card
              </Text>
            </Flex>
          </GridItem>
        </Grid> */}

        <Flex mt={6} flexDirection="column">
          {/* <Text fontWeight={800} fontSize={"14px"} pt={"5px"}>
            Sign stay agreement
          </Text>
          <Text fontWeight={500} fontSize={"12px"} pt={"5px"}>
            The stay agreement will be signed electronically, used for startas
            and apartments agreements
          </Text> */}

          {/* <Text fontWeight={800} fontSize={"14px"} pt={"15px"}>
            Add your card to file
          </Text> */}
          <Text fontWeight={800} fontSize={"14px"} pt={"15px"}>
            Control your lock
          </Text>
          {/* <Text fontWeight={500} fontSize={"12px"} pt={"5px"}>
            To be able to make a refundable deposit and/or get any add-ons you
            can add your card
          </Text> */}
          <Text fontWeight={500} fontSize={"12px"} pt={"5px"}>
            Stay safe by having full control of your lock
          </Text>

          {/* <Text fontWeight={800} fontSize={"14px"} pt={"15px"}>
            Make the deposit
          </Text> */}
          <Text fontWeight={800} fontSize={"14px"} pt={"15px"}>
            View Guides
          </Text>
          {/* <Text fontWeight={500} fontSize={"12px"} pt={"5px"}>
            Make a quick refundable deposit, given back at the end of the stay
          </Text> */}
          <Text fontWeight={500} fontSize={"12px"} pt={"5px"}>
            Learn about your area with guides provided by local experts
          </Text>
        </Flex>
      </Flex>
      <Center>
        <Grid templateColumns="repeat(4, 1fr)" gap={2} mb={4} display="none">
          <StepDisplay step={1} filled />
          <StepDisplay step={2} filled />
          <StepDisplay step={3} />
          <StepDisplay step={4} />
        </Grid>
        <Button
          //   as={RouteLink}
          //   to={"/auth"}
          onClick={() => handleStatusChange("initial")}
          color="white"
          bg={"#817EFF"}
          _hover={{ backgroundColor: "#504CFF" }}
          w={"full"}
          m={3}
          fontSize={"12px"}
          p={6}
          borderRadius={"60px"}
        >
          <>Get Started</>
        </Button>
      </Center>
    </>
  );
};

const DocumentDisplay = ({ handleStatusChange }) => {
  return (
    <>
      <Flex
        px={4}
        h={{ base: "65vh", md: "auto" }}
        justifyContent={"flex-start"}
        flexDirection="column"
        mt={{ base: "70px", md: 0 }}
        mb={{ md: 8 }}
      >
        <Center flexDirection="column" alignItems={"start"}>
          <Text fontWeight={400}>Signing Documents</Text>
          <Text fontWeight={800} fontSize={"24px"} pt={"2px"}>
            Sign you agreement documents
          </Text>
          <Text mt={1} fontWeight={800} fontSize={"14px"}>
            To stay in the unit you need to sign items here to be able to stay
            in the unit
          </Text>

          <Text mt={10} fontWeight={800} fontSize={"20px"}>
            None Found - Please continue to next step
          </Text>
        </Center>
      </Flex>
      <Center m={3} flexDirection="column">
        {/* <Grid templateColumns="repeat(4, 1fr)" gap={2} mb={4}>
          <StepDisplay step={1} filled />
          <StepDisplay step={2} />
          <StepDisplay step={3} />
          <StepDisplay step={4} />
        </Grid> */}
        <Button
          //   as={RouteLink}
          //   to={"/auth"}
          onClick={() => handleStatusChange("document")}
          color="white"
          bg={"#817EFF"}
          _hover={{ backgroundColor: "#504CFF" }}
          w={"full"}
          fontSize={"12px"}
          p={6}
          borderRadius={"60px"}
        >
          Next <Icon as={MdNavigateNext} fontSize={"22px"} />
        </Button>
      </Center>
    </>
  );
};

const CardDisplay = ({ handleStatusChange, guest }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const toast = useToast();

  useEffect(() => {
    if (guest) {
      setName(guest.name);
      setEmail(guest.email.includes("@noemail.com") ? "" : guest.email);
    }
  }, [guest]);

  const validateAndProceed = () => {
    if (!name.trim()) {
      toast({
        title: "Error",
        description: "Name cannot be empty.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    if (!email.trim() || email.includes("@noemail.com")) {
      toast({
        title: "Error",
        description: "Please provide a valid email.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
      return;
    }

    // Proceed to update guest info or next step
    updateGuestInfo();
  };

  const updateGuestInfo = async () => {
    const input = { id: guest.id, name, email };

    try {
      await API.graphql(graphqlOperation(updateGuest, { input }));
      handleStatusChange("card");
    } catch (error) {
      console.error("Error updating guest info:", error);
    }
  };

  return (
    <>
      {guest && (
        <>
          <Flex
            px={4}
            h={{ base: "65vh", md: "auto" }}
            justifyContent={"flex-start"}
            flexDirection="column"
            mt={{ base: "70px", md: 0 }}
            mb={{ md: 8 }}
          >
            <Center flexDirection="column" alignItems={"start"}>
              <Text fontWeight={400}>Confirm Details</Text>
              <Text fontWeight={800} fontSize={"24px"} pt={"2px"}>
                Add your details
              </Text>
              <Text mt={1} fontWeight={800} fontSize={"14px"}>
                To be able to offer better services make sure to add your
                details
              </Text>
              <Text mt={5} fontWeight={800} fontSize={"12px"}>
                Name
              </Text>

              <Input
                mt={1}
                type="text"
                variant="filled"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Text mt={5} fontWeight={800} fontSize={"12px"}>
                Email
              </Text>

              <Input
                mt={1}
                type="text"
                variant="filled"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Text mt={5} fontWeight={800} fontSize={"12px"}>
                Phone
              </Text>
              <Input
                mt={1}
                disabled
                type="text"
                variant="filled"
                placeholder="Phone"
                value={guest.phone}
                readOnly

                // onChange={(event) => prepItem(event.target.value)}
              />
              {/* <Grid templateColumns="repeat(2, 1fr)" gap={2}>
            <Input
              mt={4}
              disabled
              type="text"
              variant="filled"
              placeholder="MM/YY"
              // onChange={(event) => prepItem(event.target.value)}
            />
            <Input
              mt={4}
              disabled
              type="text"
              variant="filled"
              placeholder="123"
              // onChange={(event) => prepItem(event.target.value)}
            />
          </Grid> */}
              {/* <Text mt={4} fontWeight={800} fontSize={"12px"}>
            For tests please skip
          </Text> */}
              {/* <Text mt={10} fontWeight={800} fontSize={"20px"}>
            None Found - Please continue to next step
          </Text> */}
            </Center>
          </Flex>
          <Center m={3} flexDirection="column">
            <Grid templateColumns="repeat(3, 1fr)" gap={2} mb={4}>
              {/* <StepDisplay step={1} filled /> */}
              <StepDisplay step={2} filled />
              <StepDisplay step={3} />
              <StepDisplay step={4} />
            </Grid>
            <Button
              //   as={RouteLink}
              //   to={"/auth"}
              onClick={validateAndProceed}
              color="white"
              bg={"#817EFF"}
              _hover={{ backgroundColor: "#504CFF" }}
              w={"full"}
              fontSize={"12px"}
              p={6}
              borderRadius={"60px"}
            >
              Next <Icon as={MdNavigateNext} fontSize={"22px"} />
            </Button>
          </Center>
        </>
      )}
    </>
  );
};

const DepositDisplay = ({
  handleStatusChange,
  guest,
  room,
  booking,
  storedStripeId,
  manager,
  accessTimes,
}) => {
  const location = useLocation();
  
  // Check if account has extended verification metas
  const storedState = JSON.parse(localStorage.getItem("onboardingState")) || {};
  const activeManager = manager || storedState?.manager;
  const hasOwnerSecretArn = activeManager?.accountMetas?.superService?.secretArn;
  const hasRoomAutohostId = room?.accountMetas?.autohostId || storedState?.room?.accountMetas?.autohostId;
  const useExtendedVerification = hasOwnerSecretArn && hasRoomAutohostId;
  
  // Check if there's a pending verification in localStorage
  const pendingVerification = localStorage.getItem("pendingVerification");
  let shouldPoll = false;
  
  if (pendingVerification && useExtendedVerification) {
    try {
      const parsed = JSON.parse(pendingVerification);
      // Check if it's for this booking and not too old (within 30 minutes)
      const thirtyMinutes = 30 * 60 * 1000;
      shouldPoll = parsed.bookingId === booking.id && 
                   (Date.now() - parsed.timestamp) < thirtyMinutes;
    } catch (e) {
      console.error("Error parsing pendingVerification:", e);
    }
  }
  
  // Only use optimized loading (render immediately from the booking we
  // already hold, no spinner) when polling AND that booking actually
  // carries its securityItems. The /bookings/details shape doesn't include
  // that relation — seeding SecuritySteps with it renders a 0-item list
  // whose Continue button used to count as "all complete" until the real
  // GraphQL fetch landed, a window a guest could (and did) tap through to
  // reach /main-v2 with steps unfinished. No items in hand → show the
  // loading screen and wait for the authoritative fetch.
  const shouldOptimizeLoading =
    shouldPoll && (booking?.securityItems?.items?.length || 0) > 0;

  // If coming from verification with extended verification, start with cached booking and no loading screen
  const [load, setLoad] = useState(!shouldOptimizeLoading);
  const [fetchedBooking, setFetchedBooking] = useState(shouldOptimizeLoading ? booking : null);
  const [isPolling, setIsPolling] = useState(false);
  const toast = useToast();

  const fetchBooking = async (showLoading = true) => {
    if (showLoading) setLoad(true);
    try {
      const result = await API.graphql(
        graphqlOperation(getBooking, { id: booking.id })
      );
      // `getBooking` has no `guestApp` — those settings only exist on the
      // /bookings/details response. Carry them across the refetch, or the
      // booking that SecuritySteps hands to DoneDisplay → main-v2 loses
      // them and the main screen falls back to showing the lock button.
      const refetched = {
        ...result.data.getBooking,
        guestApp: booking.guestApp,
      };
      setFetchedBooking(refetched);
      return refetched;
    } catch (error) {
      console.error("Error fetching booking:", error);
      toast({
        title: "Error",
        description: "Failed to fetch booking information.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return null;
    } finally {
      if (showLoading) setLoad(false);
    }
  };

  // Update backend via polling endpoint when verification detected during polling
  const updateBackendVerification = async () => {
    try {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();
      
      if (booking?.id) {
        const response = await axios.post(
          `https://api.linkbase.ca/security/id_verify/poll/${booking.id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_LINKBASE_API_KEY,
            },
          }
        );
        console.log("✅ Backend updated via polling endpoint:", response.data);
      }
    } catch (error) {
      console.error("⚠️ Failed to update backend during polling:", error);
    }
  };

  // Initial fetch + poll only if coming back from verification pages
  useEffect(() => {
    let pollInterval;
    let pollCount = 0;
    const MAX_POLLS = 20; // 20 polls × 1s = 20 seconds

    const init = async () => {
      // Fetch in background without loading screen if polling
      const initialBooking = await fetchBooking(!shouldOptimizeLoading);
      
      // Poll if pendingVerification flag exists
      if (shouldPoll) {
        // Check immediately after initial load
        const guestIdItem = initialBooking?.securityItems?.items?.find(
          item => item.type === "GUEST_ID"
        );
        
        if (guestIdItem?.isComplete) {
          // Already complete, clear the flag
          localStorage.removeItem("pendingVerification");
          return;
        }
        
        setIsPolling(true);
        
        // Start polling with 1 second intervals for faster feedback
        pollInterval = setInterval(async () => {
          pollCount++;
          if (pollCount >= MAX_POLLS) {
            clearInterval(pollInterval);
            setIsPolling(false);
            // Clear flag after max polls
            localStorage.removeItem("pendingVerification");
            return;
          }
          
          const updatedBooking = await fetchBooking(false);
          
          // Check if verification is complete and stop polling
          if (updatedBooking) {
            const guestIdItem = updatedBooking.securityItems?.items?.find(
              item => item.type === "GUEST_ID"
            );
            if (guestIdItem?.isComplete) {
              clearInterval(pollInterval);
              setIsPolling(false);
              // Clear the flag when complete
              localStorage.removeItem("pendingVerification");
            }
          }
        }, 1000);
      }
    };

    init();

    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [booking.id, location.key, shouldPoll]);

  return (
    <>
      {load ? (
        <>
          <Center h={{ base: "100vh", md: "50vh" }}>
            <CircularProgress
              isIndeterminate
              color="#504CFF"
              size={"40px"}
              trackColor="transparent"
            />
          </Center>
        </>
      ) : (
        <>
          <SecuritySteps
            guest={guest}
            room={room}
            booking={fetchedBooking}
            handleStatusChange={handleStatusChange}
            storedStripeId={storedStripeId}
            manager={manager}
            accessTimes={accessTimes}
            isPolling={isPolling}
          />
          {isPolling && (
            <Box
              position="fixed"
              bottom="0"
              left="0"
              right="0"
              bg="rgba(45, 55, 72, 0.95)"
              backdropFilter="blur(10px)"
              borderTop="1px solid"
              borderColor="rgba(129, 126, 255, 0.3)"
              py={2}
              px={4}
              zIndex={1000}
            >
              <Flex alignItems="center" justifyContent="center" gap={2}>
                <Spinner size="xs" color="#817EFF" />
                <Text fontSize="12px" fontWeight="500" color="#A0AEC0">
                  Checking verification status...
                </Text>
              </Flex>
            </Box>
          )}
        </>
      )}
    </>
  );
};

const DoneDisplay = ({ room, booking, manager, accessTimes, upsellID }) => {
  const navigate = useNavigate();
  const [isFormsOpen, setIsFormsOpen] = useState(false);
  const [hasAnyForms, setHasAnyForms] = useState(false);
  const [hasOpenForms, setHasOpenForms] = useState(false);
  const [hasOpenRequiredForms, setHasOpenRequiredForms] = useState(false);
  const [formsLoading, setFormsLoading] = useState(true);

  const refreshFormsStatus = React.useCallback(async () => {
    if (!booking?.id) {
      setFormsLoading(false);
      return;
    }
    setFormsLoading(true);
    try {
      const res = await listFormsForBooking(booking.id);
      const items = res?.data?.items || res?.data?.forms || [];
      setHasAnyForms(items.length > 0);
      const open = items.some((it) => {
        const status = it?.response?.status;
        if (it?.form?.isRequired) return status !== "submitted";
        return status !== "submitted" && status !== "skipped";
      });
      setHasOpenForms(open);
      const requiredOpen = items.some(
        (it) => it?.form?.isRequired && it?.response?.status !== "submitted"
      );
      setHasOpenRequiredForms(requiredOpen);
    } catch (e) {
      console.warn("Failed to load forms for booking:", e?.message || e);
      setHasAnyForms(false);
      setHasOpenForms(false);
      setHasOpenRequiredForms(false);
    } finally {
      setFormsLoading(false);
    }
  }, [booking?.id]);

  useEffect(() => {
    refreshFormsStatus();
  }, [refreshFormsStatus]);

  const handleSelect = () => {
    // If the guest arrived via an upsell deep-link and had to finish
    // security first, send them back to the dedicated /upsell page so
    // the purchase drawer opens immediately — not through landing.
    if (upsellID && booking?.id) {
      navigate(
        `/upsell?bID=${encodeURIComponent(booking.id)}&upsellID=${encodeURIComponent(upsellID)}`,
        { replace: true }
      );
      return;
    }
    const isV2 = sessionStorage.getItem('isV2') === 'true';
    navigate(isV2 ? '/main-v2' : '/main', {
      state: { room, booking, manager, accessTimes },
    });
  };

  // The "primary" thing the guest should do next, mirrored across
  // the footer button and every clickable card in the body. Some
  // devices clip the fixed footer under safe-area / keyboard chrome
  // and guests couldn't see the CTA at all — making the info cards
  // themselves trigger the exact same action gives everyone a
  // reachable tap target. `null` while forms are still loading so
  // taps don't fire prematurely against an unresolved state.
  const primaryAction = formsLoading
    ? null
    : hasOpenForms
      ? () => setIsFormsOpen(true)
      : handleSelect;

  // Animated gradient + soft glow, ported 1:1 from CheckInButton so
  // the primary footer CTA reads as "you can tap this" even at the
  // bottom of a scrollable page. Applied to both the survey button
  // and the "View Your Stay" button (whichever is showing) so the
  // visual language stays consistent across the two states.
  const livelyButtonSx = {
    backgroundImage:
      "linear-gradient(270deg,#8B5CF6,#7C3AED,#6366F1,#A855F7,#8B5CF6)",
    backgroundSize: "300% 300%",
    animation:
      "doneLivelyGrad 4s ease infinite, doneLivelyGlow 2.5s ease-in-out infinite",
    "@keyframes doneLivelyGrad": {
      "0%": { backgroundPosition: "0% 50%" },
      "50%": { backgroundPosition: "100% 50%" },
      "100%": { backgroundPosition: "0% 50%" },
    },
    "@keyframes doneLivelyGlow": {
      "0%, 100%": { boxShadow: "0 0 0 0 rgba(139,92,246,0)" },
      "50%": { boxShadow: "0 0 18px 4px rgba(139,92,246,0.4)" },
    },
    "&:active": { transform: "scale(0.97)" },
    transition: "transform 0.1s ease",
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return DateTime.fromISO(dateStr).toFormat("EEE, MMM d");
  };

  const nights = (() => {
    if (!booking?.checkInDate || !booking?.checkOutDate) return null;
    const checkIn = DateTime.fromISO(booking.checkInDate);
    const checkOut = DateTime.fromISO(booking.checkOutDate);
    const n = checkOut.diff(checkIn, "days").days;
    return n > 0 ? Math.round(n) : null;
  })();

  return (
    <Flex
      direction="column"
      minH={{ base: "100vh", md: "auto" }}
      px={{ base: 4, md: 0 }}
      pt={{ base: "60px", md: 0 }}
      pb="100px"
    >
      <Box>
        <Flex align="center" gap={3} mb={2}>
          <Center bg="green.400" h="44px" w="44px" borderRadius="full" flexShrink={0}>
            <Icon as={MdOutlineDone} fontSize="22px" color="white" />
          </Center>
          <Box>
            <Text fontSize="13px" color="gray.400" fontWeight={500}>
              Verification complete
            </Text>
            <Text fontSize="22px" fontWeight={700} lineHeight="1.2" letterSpacing="-0.02em">
              You’re all set
            </Text>
          </Box>
        </Flex>

        {(booking?.checkInDate || booking?.checkOutDate) && (
          <Box
            mt={5} p={4} borderRadius="16px"
            bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.100"
          >
            <Text
              fontSize="10px" fontWeight={600} textTransform="uppercase"
              letterSpacing="0.06em" color="gray.500" mb={3}
            >
              Your stay
            </Text>
            <Flex justify="space-between" align="center">
              <Box>
                <Text fontSize="11px" color="gray.500" fontWeight={500}>Check-in</Text>
                <Text fontSize="15px" fontWeight={600}>{formatDate(booking.checkInDate)}</Text>
              </Box>
              {nights && (
                <Box textAlign="center" px={3}>
                  <Text fontSize="20px" fontWeight={700} color="#817EFF">{nights}</Text>
                  <Text fontSize="10px" color="gray.500" fontWeight={500}>
                    {nights === 1 ? "night" : "nights"}
                  </Text>
                </Box>
              )}
              <Box textAlign="right">
                <Text fontSize="11px" color="gray.500" fontWeight={500}>Check-out</Text>
                <Text fontSize="15px" fontWeight={600}>{formatDate(booking.checkOutDate)}</Text>
              </Box>
            </Flex>
          </Box>
        )}

        <Box mt={6}>
          {hasAnyForms && (
            <>
              <Text
                fontSize="10px" fontWeight={600} textTransform="uppercase"
                letterSpacing="0.06em" color="gray.500" mb={3}
              >
                From your host
              </Text>
              <Flex
                as="button"
                align="center" gap={3} p={3} borderRadius="14px"
                bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.100"
                _hover={{ bg: "whiteAlpha.100" }}
                _active={{ bg: "whiteAlpha.200", transform: "scale(0.99)" }}
                transition="all 0.15s ease"
                textAlign="left" w="full" mb={5}
                onClick={() => setIsFormsOpen(true)}
              >
                <Center w="36px" h="36px" borderRadius="10px" bg="whiteAlpha.100" flexShrink={0}>
                  <Icon as={MdOutlineAssignment} fontSize="14px" color="#817EFF" />
                </Center>
                <Box flex="1" minW={0}>
                  <Text fontSize="13px" fontWeight={600}>Forms from your host</Text>
                  <Text fontSize="11px" color="gray.400" lineHeight="1.4">
                    Quick questions your host has for your stay.
                  </Text>
                </Box>
                <Icon as={MdNavigateNext} fontSize="18px" color="whiteAlpha.500" />
              </Flex>
            </>
          )}

          <Text
            fontSize="10px" fontWeight={600} textTransform="uppercase"
            letterSpacing="0.06em" color="gray.500" mb={3}
          >
            What you can do
          </Text>
          <Flex direction="column" gap={3}>
            {[
              { icon: MdNavigateNext, title: "Check-in instructions", desc: "Step-by-step instructions to get settled into your space." },
              { icon: BsBookFill, title: "Guidebooks & house rules", desc: "Everything you need to know about your space and area." },
              { icon: AiTwotoneBulb, title: "Services & extras", desc: "Browse add-ons like early check-in, late checkout, and more." },
            ].map((item, i) => (
              <Flex
                key={i}
                as="button"
                type="button"
                align="center"
                gap={3}
                p={3}
                borderRadius="12px"
                bg="whiteAlpha.50"
                border="1px solid"
                borderColor="whiteAlpha.100"
                textAlign="left"
                w="full"
                onClick={primaryAction || undefined}
                cursor={primaryAction ? "pointer" : "not-allowed"}
                opacity={primaryAction ? 1 : 0.6}
                disabled={!primaryAction}
                _hover={primaryAction ? { bg: "whiteAlpha.100" } : {}}
                _active={
                  primaryAction
                    ? { bg: "whiteAlpha.200", transform: "scale(0.99)" }
                    : {}
                }
                transition="all 0.15s ease"
              >
                <Center w="36px" h="36px" borderRadius="10px" bg="whiteAlpha.100" flexShrink={0}>
                  <Icon as={item.icon} fontSize="14px" color="#817EFF" />
                </Center>
                <Box flex="1" minW={0}>
                  <Text fontSize="13px" fontWeight={600}>{item.title}</Text>
                  <Text fontSize="11px" color="gray.400" lineHeight="1.4">{item.desc}</Text>
                </Box>
                <Icon as={MdNavigateNext} fontSize="18px" color="whiteAlpha.500" />
              </Flex>
            ))}
          </Flex>
        </Box>
      </Box>

      <Box
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        maxW={{ md: "600px" }}
        mx="auto"
        px={4}
        pb="env(safe-area-inset-bottom)"
        pt={3}
        bg="linear-gradient(to top, #1a202c 60%, transparent)"
        style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 16px)" }}
      >
        {formsLoading ? (
          <Center
            w="full" h="50px" borderRadius="14px"
            bg="whiteAlpha.50" border="1px solid" borderColor="whiteAlpha.100"
          >
            <Spinner size="sm" color="#817EFF" thickness="2px" />
          </Center>
        ) : hasOpenForms ? (
          <>
            <Button
              onClick={() => setIsFormsOpen(true)}
              color="white"
              w="full"
              h="50px"
              fontSize="14px"
              fontWeight={600}
              borderRadius="14px"
              leftIcon={<Icon as={MdOutlineAssignment} fontSize="18px" />}
              sx={livelyButtonSx}
            >
              {hasOpenRequiredForms ? "Take Required Survey" : "Take Survey"}
            </Button>
            {!hasOpenRequiredForms && (
              <Button
                onClick={handleSelect}
                variant="ghost"
                color="whiteAlpha.700"
                w="full" h="40px" mt={2}
                fontSize="13px" fontWeight={600} borderRadius="12px"
                _hover={{ bg: "whiteAlpha.100", color: "white" }}
                _active={{ bg: "whiteAlpha.200" }}
              >
                Skip and view your stay
              </Button>
            )}
          </>
        ) : (
          <Button
            onClick={handleSelect}
            color="white"
            w="full"
            h="50px"
            fontSize="14px"
            fontWeight={600}
            borderRadius="14px"
            rightIcon={<Icon as={MdNavigateNext} fontSize="20px" />}
            sx={livelyButtonSx}
          >
            View Your Stay
          </Button>
        )}
      </Box>

      <FormsDrawer
        isOpen={isFormsOpen}
        onClose={() => {
          setIsFormsOpen(false);
          refreshFormsStatus();
        }}
        bookingId={booking?.id}
        guestId={booking?.guestID}
        roomId={booking?.roomID || room?.id}
      />
    </Flex>
  );
};

// const Emailling = ({ handleStatusChange }) => {
//   const [components, setComponents] = useState([0]);

//   const handleClick = () => {
//     setComponents([...components, components.length]);
//   };
//   const handleRemove = (index) => {
//     setComponents(components.filter((_, i) => i !== index));
//   };

//   return (
//     <>
//       <Flex
//         px={4}
//         h={"65vh"}
//         justifyContent={"flex-start"}
//         flexDirection="column"
//         mt={"70px"}
//       >
//         <Center flexDirection="column" alignItems={"start"}>
//           <Text fontWeight={400}>Emails</Text>

//           <Text mt={1} fontWeight={800} fontSize={"14px"}>
//             Please add your email and guests
//           </Text>

//           {components.map((_, index) => (
//             <Flex key={index} w="full" alignItems={"center"}>
//               <InputGroup mt={4}>
//                 <InputLeftElement pointerEvents="none" children={<MdEmail />} />
//                 <Input
//                   type="email"
//                   variant="filled"
//                   placeholder="john@acme.com"
//                   // onChange={(event) => prepItem(event.target.value)}
//                 />
//               </InputGroup>
//               <Button ml={2} mt={4} onClick={() => handleRemove(index)}>
//                 -
//               </Button>
//             </Flex>
//           ))}
//           <Button mt={2} onClick={handleClick}>
//             +
//           </Button>
//         </Center>
//       </Flex>
//       <Center m={3} flexDirection="column">
//         <Grid templateColumns="repeat(4, 1fr)" gap={2} mb={4}>
//           <StepDisplay step={1} filled />
//           <StepDisplay step={2} />
//           <StepDisplay step={3} />
//           <StepDisplay step={4} />
//           <StepDisplay step={5} />
//         </Grid>
//         <Button
//           //   as={RouteLink}
//           //   to={"/auth"}
//           onClick={() => handleStatusChange("email")}
//           color="white"
//           bg={"#817EFF"}
//           _hover={{ backgroundColor: "#504CFF" }}
//           w={"full"}
//           p={6}
//           fontSize={"12px"}
//           borderRadius={"60px"}
//         >
//           Next <Icon as={MdNavigateNext} fontSize={"22px"} />
//         </Button>
//       </Center>
//     </>
//   );
// };

const StepChecker = ({
  booking,
  room,
  guest,
  handleStatusChange,
  storedStripeId,
  manager,
  accessTimes,
  upsellID,
}) => {
  const status = booking.status;

  if (!status) {
    return (
      <Center minH={{ md: "50vh" }}>
        <CircularProgress
          isIndeterminate
          color="#504CFF"
          size={"40px"}
          trackColor="transparent"
        />
      </Center>
    );
  }

  // Server-truth gate. /go (useLandingV2Logic) writes
  // `securityStepsComplete` onto the booking handed to /onboarding.
  // When it's explicitly `false`, force the SecuritySteps screen
  // regardless of `status.deposit` — otherwise a stale
  // `{deposit:true, done:false}` row sends the user to DoneDisplay
  // ("View Your Stay") which navigates to /main-v2, whose own guard
  // bounces them right back to /onboarding (infinite loop). This
  // happens whenever the server has invalidated the security items
  // after the deposit flag was set (e.g. ID verification rejected).
  // Strict `=== false`: an `undefined` flag (legacy navigation paths
  // that never set it) falls through to the original status-driven
  // routing below.
  if (booking.securityStepsComplete === false) {
    return (
      <OnboardingShell>
        <DepositDisplay
          handleStatusChange={handleStatusChange}
          guest={guest}
          room={room}
          booking={booking}
          storedStripeId={storedStripeId}
          manager={manager}
          accessTimes={accessTimes}
        />
      </OnboardingShell>
    );
  }

  // else if (
  //   status.initial &&
  //   !status.email &&
  //   !status.document &&
  //   !status.card &&
  //   !status.deposit &&
  //   !status.done
  // ) {
  //   return <Emailling handleStatusChange={handleStatusChange} />;
  // }
  else if (
    status.initial &&
    !status.document &&
    !status.card &&
    !status.deposit &&
    !status.done
  ) {
    return (
      <OnboardingShell>
        <DocumentDisplay handleStatusChange={handleStatusChange} />
      </OnboardingShell>
    );
  } else if (
    status.initial &&
    status.document &&
    !status.card &&
    !status.deposit &&
    !status.done
  ) {
    return (
      <OnboardingShell>
        <CardDisplay handleStatusChange={handleStatusChange} guest={guest} />
      </OnboardingShell>
    );
  } else if (
    status.initial &&
    status.document &&
    status.card &&
    !status.deposit &&
    !status.done
  ) {
    return (
      <OnboardingShell>
        <DepositDisplay
          handleStatusChange={handleStatusChange}
          guest={guest}
          room={room}
          booking={booking}
          storedStripeId={storedStripeId}
          manager={manager}
          accessTimes={accessTimes}
        />
      </OnboardingShell>
    );
  } else if (
    status.initial &&
    status.document &&
    status.card &&
    status.deposit &&
    !status.done
  ) {
    return (
      <OnboardingShell>
        <DoneDisplay
          room={room}
          booking={booking}
          handleStatusChange={handleStatusChange}
          manager={manager}
          accessTimes={accessTimes}
          upsellID={upsellID}
        />
      </OnboardingShell>
    );
  } else if (
    status.initial &&
    status.document &&
    status.card &&
    status.deposit &&
    status.done
  ) {
    return <Main room={room} />;
  } else {
    return (
      <OnboardingShell>
        <IntialDisplay handleStatusChange={handleStatusChange} />
      </OnboardingShell>
    );
  }
};

export const Onboarding = () => {
  const [dbBooking, setBooking] = useState({});
  const [guest, setGuest] = useState(null);
  const location = useLocation();
  const { room, booking, storedStripeId, manager: locationManager, accessTimes, upsellID } =
    location.state || JSON.parse(localStorage.getItem("onboardingState")) || {};

  // Get manager data from Redux store
  const reduxManager = useSelector((state) => ({
    email: state.user.email,
    password: state.user.password,
    stripeId: state.user.stripeId,
    name: state.user.managerName,
    images: state.user.managerImages,
    accountMetas: state.user.accountMetas,
    extendedMetas: state.user.extendedMetas,
  }));

  // Use location manager if available (includes accountMetas and extendedMetas), otherwise use Redux manager
  const manager = locationManager || reduxManager;

  // Intro video drawer state — persisted in sessionStorage so navigating back doesn't re-trigger it
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [hasShownVideo, setHasShownVideo] = useState(
    () => sessionStorage.getItem('introVideoShown') === 'true'
  );

  const dismissVideo = () => {
    sessionStorage.setItem('introVideoShown', 'true');
    setHasShownVideo(true);
    onClose();
  };

  // Auto-open intro video drawer only when there are incomplete onboarding steps
  useEffect(() => {
    const status = dbBooking?.status;
    if (!status) return;
    const allStepsComplete = status.initial && status.document && status.card && status.deposit;
    if (!hasShownVideo && !allStepsComplete && manager?.extendedMetas?.hasIntroVideo && manager?.extendedMetas?.introVideoUrl) {
      const timer = setTimeout(() => {
        onOpen();
        sessionStorage.setItem('introVideoShown', 'true');
        setHasShownVideo(true);
      }, 800);
      
      return () => clearTimeout(timer);
    }
  }, [manager, hasShownVideo, onOpen, dbBooking?.status]);

  useEffect(() => {
    if (!booking) return;

    // booking.status used to always be a JSON-encoded string from the
    // backend; the /bookings/details endpoint now returns it pre-parsed
    // as an object on some shapes. Handle both — and a malformed
    // string defensively — so the screen doesn't blow up with
    // "[object Object] is not valid JSON" when it's already an object.
    let parsedStatus = booking.status;
    if (typeof booking.status === "string") {
      try {
        parsedStatus = JSON.parse(booking.status);
      } catch (err) {
        console.error("Failed to parse booking.status:", err);
        parsedStatus = null;
      }
    }

    setBooking({ ...booking, status: parsedStatus });

    if (booking.guestID) {
      fetchGuestData(booking.guestID).then(setGuest);
    }
  }, [booking]);

  const fetchGuestData = async (guestID) => {
    try {
      const result = await API.graphql(
        graphqlOperation(getGuest, { id: guestID })
      );

      return result.data.getGuest;
    } catch (error) {
      console.error("Error fetching guest data:", error);
      return null;
    }
  };

  const handleStatusChange = (key) => {
    const status = dbBooking.status;
    const updated = { ...status, [key]: true };
    const jsonString = JSON.stringify(updated);

    updateBookingFunc(jsonString, (updatedVersion) => {
      const statusInfo = { ...dbBooking.status, [key]: true };
      setBooking({
        ...dbBooking,
        status: statusInfo,
        // The "deposit" step is the last gate inside SecuritySteps —
        // by definition we only get here once every security item is
        // complete (the Continue button is disabled otherwise). Mark
        // the server-truth flag locally so StepChecker's
        // `securityStepsComplete === false` gate doesn't re-fire and
        // bounce the user back into SecuritySteps after they've
        // already finished, in cases where SecuritySteps doesn't
        // remount the page (e.g. status update only, no navigate).
        ...(key === "deposit" ? { securityStepsComplete: true } : {}),
        _version: updatedVersion,
      });
    });
  };

  const updateBookingFunc = async (status, callback) => {
    try {
      const item = {
        id: booking.id,
        status,
      };
      const result = await API.graphql(
        graphqlOperation(updateBooking, { input: item })
      );

      console.log("Booking updated successfully:", result.data.updateBooking);

      if (callback) callback(result.data.updateBooking._version);
    } catch (error) {
      console.log("Error updating booking:", error);
    }
  };

  return (
    <>
      <StepChecker
        booking={dbBooking}
        room={room}
        guest={guest}
        storedStripeId={storedStripeId}
        handleStatusChange={handleStatusChange}
        manager={manager}
        accessTimes={accessTimes}
        upsellID={upsellID}
      />

      {/* Intro Video Drawer - Auto-opens if configured */}
      <IntroVideoDrawer
        isOpen={isOpen}
        onClose={dismissVideo}
        videoUrl={manager?.extendedMetas?.introVideoUrl}
        propertyName={manager?.name}
      />
    </>
  );
};
